
export const margin = { top: 20, right: 0, bottom: 20, left: 200 };
export const levelDepth = 260;
export const nodeSize = 100;
export const fontWidth = 11;
export const duration = 750;